import React, { useState } from "react";

import { BiotechIcon } from "assets/icons";
import { UserLimitModal } from "components/account/UserLimitModal/UserLimitModal";
import { CreateDetectorModal } from "components/createDetector/CreateDetectorModal";
import { useModalLimit } from "hooks/useModalLimit/useModalLimit";
import { GroundlightButton } from "new-components/buttons/GroundlightButton";

interface NewDetectorButtonProps {
  onPage?: boolean;
  numDetectors?: number;
}

export function NewDetectorButton(props: NewDetectorButtonProps) {
  const { onPage, numDetectors } = props;
  const { isBlocked, modalLimit, handleOpenModalLimit, handleCloseModalLimit } = useModalLimit("detectorIsBlocked");
  const [dialogOpen, setDialogOpen] = useState(onPage || false);

  const handleOpen = () => {
    if (isBlocked) {
      handleOpenModalLimit();
      return;
    }

    setDialogOpen(true);
  };

  return (
    <>
      {!onPage ? (
        <GroundlightButton aria-label="create-detector" onClick={handleOpen} endIcon={BiotechIcon} fullWidth>
          Create new
        </GroundlightButton>
      ) : undefined}
      {modalLimit && (
        <UserLimitModal type="detector" isModalOpen={modalLimit} handleCloseModal={handleCloseModalLimit} />
      )}
      {dialogOpen && (
        <CreateDetectorModal dialogOpen={dialogOpen} setDialogOpen={setDialogOpen} numDetectors={numDetectors} />
      )}
    </>
  );
}
